import { call, put, takeEvery } from 'redux-saga/effects'
import {
    GET_TERRAINS,
    STORE_TERRAIN_REQUEST,
    DELETE_TERRAIN_REQUEST,
    GET_TERRAIN_REQUEST,
    POST_TERRAIN_STAFF_REQUEST,
    GET_TERRAIN_PLANNING_REQUEST,
    GET_TERRAINS_ASSESSMENT_REQUEST,
    GET_TERRAINS_STAFF_MATCHING_REQUEST,
    POST_TERRAINS_AUTO_STAFF_MATCHING_REQUEST,
    POST_TERRAINS_STAFF_CONFIRMATION_REQUEST,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_REQUEST,
    POST_TALENT_ASSESSMENT_ACTION_REQUEST,
    POST_TERRAIN_STATS_DAILY_REQUEST,
    POST_TERRAIN_STAFF_ADD_REQUEST
} from '../action-types'
import {
    getTerrainsApi,
    storeTerrainApi,
    deleteTerrainApi,
    getTerrainApi,
    postTerrainStaffApi,
    getTerrainPlanningApi,
    getTerrainsAssessmentApi,
    getTerrainsStaffMatchingApi,
    postTerrainsAutoStaffMatchingApi,
    postTerrainsStaffConfirmationApi,
    postTerrainsAutoStaffMatchingTrackingApi,
    postTalentAssessmentActionApi,
    postTerrainStatsDailyApi,
    postTerrainStaffAddApi
} from '../api/Terrain'
import {
    getTerrainsSuccess,
    storeTerrainSuccess,
    storeTerrainFailure,
    deleteTerrainSuccess,
    deleteTerrainFailure,
    getTerrains,
    getTerrainSuccess,
    getTerrainFailure,
    postTerrainStaffSuccess,
    postTerrainStaffFailure,
    getTerrainPlanningSuccess,
    getTerrainPlanningFailure,
    getTerrainsAssessmentSuccess,
    getTerrainsAssessmentFailure,
    getTerrainsStaffMatchingSuccess,
    getTerrainsStaffMatchingFailure,
    postTerrainsAutoStaffMatchingSuccess,
    postTerrainsAutoStaffMatchingFailure,
    postTerrainsStaffConfirmationSuccess,
    postTerrainsStaffConfirmationFailure,
    postTerrainsAutoStaffMatchingTrackingSuccess,
    postTerrainsAutoStaffMatchingTrackingFailure,
    postTalentAssessmentActionSuccess,
    postTalentAssessmentActionFailure,
    postTerrainStatsDailySuccess,
    postTerrainStatsDailyFailure,
    postTerrainStaffAddSuccess,
    postTerrainStaffAddFailure
} from '../actions/Terrain'
import { fetchError, fetchExpired, fetchStart, fetchSuccess } from '../actions/Common'
import { toast } from 'react-toastify'

function* getTerrainsSaga({ token }) {
    try {
        yield put(fetchStart())
        const response = yield call(getTerrainsApi, token)
        if (response.status === 200) {
            yield put(getTerrainsSuccess(response))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response))
        }
    } catch (error) {
        console.error('Error fetching alerts:', error)
        yield put(fetchError(error))
    }
}

function* storeTerrainSaga({ token, terrainData }) {
    try {
        yield put(fetchStart())
        const response = yield call(storeTerrainApi, token, terrainData)
        if (response.status === 201) {
            yield put(storeTerrainSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error storing terrain:', error)
        yield put(storeTerrainFailure(error))
        yield put(fetchError(error))
    }
}

function* deleteTerrainSaga({ token, terrainId }) {
    try {
        yield put(fetchStart())
        const response = yield call(deleteTerrainApi, token, terrainId)
        if (response.status === 200) {
            yield put(deleteTerrainSuccess(response.data))
            yield put(fetchSuccess())
            toast.success('Terrain deleted successfully')
            // Refetch terrains to update the list
            yield put(getTerrains(token))
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
            yield put(fetchSuccess())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error deleting terrain:', error)
        yield put(deleteTerrainFailure(error))
        yield put(fetchError(error))
    }
}

function* getTerrainSaga({ token, terrainId }) {
    try {
        yield put(fetchStart())
        const response = yield call(getTerrainApi, token, terrainId)
        if (response.status === 200) {
            yield put(getTerrainSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 404) {
            toast.error('Terrain not found')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error fetching terrain:', error)
        yield put(getTerrainFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainStaffSaga({ token, terrainId, staffData }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTerrainStaffApi, token, terrainId, staffData)
        if (response.status === 200) {
            yield put(postTerrainStaffSuccess(response.data))
            yield put(fetchSuccess())
            //toast.success('Staff posted successfully')
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 404) {
            toast.error('Terrain not found')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting terrain staff:', error)
        yield put(postTerrainStaffFailure(error))
        yield put(fetchError(error))
    }
}

function* getTerrainPlanningSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(getTerrainPlanningApi, token, params)
        if (response.status === 200) {
            yield put(getTerrainPlanningSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 404) {
            toast.error('Planning data not found')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error fetching terrain planning:', error)
        yield put(getTerrainPlanningFailure(error))
        yield put(fetchError(error))
    }
}

function* getTerrainsAssessmentSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(getTerrainsAssessmentApi, token, params)
        if (response.status === 200) {
            yield put(getTerrainsAssessmentSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 404) {
            toast.error('Assessment data not found')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error fetching terrain assessment:', error)
        yield put(getTerrainsAssessmentFailure(error))
        yield put(fetchError(error))
    }
}

function* getTerrainsStaffMatchingSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(getTerrainsStaffMatchingApi, token, params)
        if (response.status === 200) {
            yield put(getTerrainsStaffMatchingSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 404) {
            toast.error('Staff matching data not found')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error fetching terrain staff matching:', error)
        yield put(getTerrainsStaffMatchingFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainsAutoStaffMatchingSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTerrainsAutoStaffMatchingApi, token, params)
        if (response.status === 200) {
            yield put(postTerrainsAutoStaffMatchingSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting terrain auto staff matching:', error)
        yield put(postTerrainsAutoStaffMatchingFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainsStaffConfirmationSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTerrainsStaffConfirmationApi, token, params)
        if (response.status === 200) {
            yield put(postTerrainsStaffConfirmationSuccess(response.data))
            yield put(fetchSuccess())
            toast.success('Staff confirmation submitted successfully')
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting terrain staff confirmation:', error)
        yield put(postTerrainsStaffConfirmationFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainsAutoStaffMatchingTrackingSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTerrainsAutoStaffMatchingTrackingApi, token, params)
        if (response.status === 200) {
            yield put(postTerrainsAutoStaffMatchingTrackingSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting terrain auto staff matching tracking:', error)
        yield put(postTerrainsAutoStaffMatchingTrackingFailure(error))
        yield put(fetchError(error))
    }
}

function* postTalentAssessmentActionSaga({ token, params }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTalentAssessmentActionApi, token, params)
        if (response.status === 200) {
            yield put(postTalentAssessmentActionSuccess(response.data))
            yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 422) {
            toast.error('Validation error')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting talent assessment action:', error)
        yield put(postTalentAssessmentActionFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainStatsDailySaga({ token, params }) {
    try {
        //yield put(fetchStart())
        const response = yield call(postTerrainStatsDailyApi, token, params)
        if (response.status === 200) {
            yield put(postTerrainStatsDailySuccess(response.data))
            //yield put(fetchSuccess())
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error posting terrain stats daily:', error)
        yield put(postTerrainStatsDailyFailure(error))
        yield put(fetchError(error))
    }
}

function* postTerrainStaffAddSaga({ token, staffData }) {
    try {
        yield put(fetchStart())
        const response = yield call(postTerrainStaffAddApi, token, staffData)
        if (response.status === 200) {
            yield put(postTerrainStaffAddSuccess(response.data))
            yield put(fetchSuccess())
            toast.success('Staff added successfully')
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 403) {
            toast.error('Access denied')
        }
        if (response.status === 422) {
            toast.error('Validation error')
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.error('Error adding terrain staff:', error)
        yield put(postTerrainStaffAddFailure(error))
        yield put(fetchError(error))
    }
}

export default function* terrainSaga() {
    yield takeEvery(GET_TERRAINS, getTerrainsSaga)
    yield takeEvery(STORE_TERRAIN_REQUEST, storeTerrainSaga)
    yield takeEvery(DELETE_TERRAIN_REQUEST, deleteTerrainSaga)
    yield takeEvery(GET_TERRAIN_REQUEST, getTerrainSaga)
    yield takeEvery(POST_TERRAIN_STAFF_REQUEST, postTerrainStaffSaga)
    yield takeEvery(GET_TERRAIN_PLANNING_REQUEST, getTerrainPlanningSaga)
    yield takeEvery(GET_TERRAINS_ASSESSMENT_REQUEST, getTerrainsAssessmentSaga)
    yield takeEvery(GET_TERRAINS_STAFF_MATCHING_REQUEST, getTerrainsStaffMatchingSaga)
    yield takeEvery(POST_TERRAINS_AUTO_STAFF_MATCHING_REQUEST, postTerrainsAutoStaffMatchingSaga)
    yield takeEvery(POST_TERRAINS_STAFF_CONFIRMATION_REQUEST, postTerrainsStaffConfirmationSaga)
    yield takeEvery(POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_REQUEST, postTerrainsAutoStaffMatchingTrackingSaga)
    yield takeEvery(POST_TALENT_ASSESSMENT_ACTION_REQUEST, postTalentAssessmentActionSaga)
    yield takeEvery(POST_TERRAIN_STATS_DAILY_REQUEST, postTerrainStatsDailySaga)
    yield takeEvery(POST_TERRAIN_STAFF_ADD_REQUEST, postTerrainStaffAddSaga)
}
